import { useCallback, useMemo } from "react";
import type { AntiBotMeta } from "../constants/antiBot";
import { resolveAntiBotStrategy } from "./antibot/strategies";

export const ANTIBOT_ACTIONS = {
  FORM_SUBMIT: "form_submit",
  WHATSAPP_CONTACT: "whatsapp_contact",
} as const;

export const useAntiBot = (antiBot?: AntiBotMeta | null) => {
  const provider = antiBot?.provider ?? null;
  const publicConfig = antiBot?.publicConfig ?? null;
  const strategy = useMemo(() => resolveAntiBotStrategy(provider), [provider]);

  const requestScript = useCallback(() => {
    if (!strategy || !publicConfig) {
      return;
    }
    strategy.ensureScript(publicConfig);
  }, [strategy, publicConfig]);

  const execute = useCallback(
    async (action: string): Promise<string | null> => {
      if (!strategy || !publicConfig) {
        return null;
      }
      requestScript();
      return strategy.execute(action, publicConfig);
    },
    [strategy, publicConfig, requestScript],
  );

  return { execute, requestScript };
};
